//#region src/sdk/const.ts
const internalGlobalObjectKey = "_faroInternal";
//#endregion
export { internalGlobalObjectKey };

//# sourceMappingURL=const.js.map